var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"x-small":"","icon":""},on:{"click":function($event){return _vm.copyToClipBoard(_vm.value)}}},[_c('v-icon',{domProps:{"textContent":_vm._s('mdi-content-copy')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }